import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const propertyAssetTenantService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    PROPERTY_ASSET_TENANT: 'property-asset-tenants',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            property_asset: filter?.propertyAsset,
            company: filter?.company,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_ASSET_TENANT}`, request);
}

export function store (data) {
    const request = {
        property_asset_uuid: data?.propertyAssetUuid,
        rental_size_unit_uuid: data?.rentalSizeUnitUuid,
        customer: data?.customer,
        customer_contact: data?.customerContact,
        rental_value_psf: data?.rentalValuePsf,
        rental_value_total: data?.rentalValueTotal,
        rental_date: data?.rentalDate,
        rental_size: data?.rentalSize,
        reminder_date: data?.reminderDate,
        need_reminder: data?.needReminder,
        remark: data?.remark,
    };

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY_ASSET_TENANT}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_ASSET_TENANT}/${uuid}`);
}

export function update (data) {
    const request = {
        property_asset_uuid: data?.propertyAssetUuid,
        rental_size_unit_uuid: data?.rentalSizeUnitUuid,
        customer: data?.customer,
        customer_contact: data?.customerContact,
        rental_value_psf: data?.rentalValuePsf,
        rental_value_total: data?.rentalValueTotal,
        rental_date: data?.rentalDate,
        rental_size: data?.rentalSize,
        reminder_date: data?.reminderDate,
        need_reminder: data?.needReminder,
        remark: data?.remark,
    };

    return apiHelper(API_URL).put(`/${MODULE.PROPERTY_ASSET_TENANT}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_ASSET_TENANT}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_ASSET_TENANT}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.PROPERTY_ASSET_TENANT}/${data.uuid}`);
}